/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { GuestConfig } from "../types/GuestConfig";
export const Request = core.serialization.list(GuestConfig);
